import React from "react"
import EventDetailsModal from "pages/EventShow/Forms/StyleAndConfiguration/StyleAndConfigurationModals/EventDetailsModal"
import EventImageAndVideoModal from "pages/EventShow/Forms/StyleAndConfiguration/StyleAndConfigurationModals/EventImageAndVideoModal"
import MapLinkModal from "pages/EventShow/Forms/StyleAndConfiguration/StyleAndConfigurationModals/MapLinkModal"
import PageLogoModal from "pages/EventShow/Forms/StyleAndConfiguration/StyleAndConfigurationModals/PageLogoModal"
import { DioboxEvent } from "sharedTypes"
import PageHeaderModal from "./PageHeaderModal"
import DioboxBrandingModal from "./DioboxBrandingModal"
import EventTitleModal from "./EventTitleModal"

export enum StyleAndConfigurationModalName {
  PageLogo,
  PageHeader,
  PublicEventTitle,
  EventDetails,
  MapLink,
  EventImageAndVideo,
  DioboxBranding,
}

type Props = {
  modalName: StyleAndConfigurationModalName | null
  onHide: () => void
  event: DioboxEvent
  updateEvent: (params: {}) => Promise<void>
  onChangeEventWorkingCopy: (values: Partial<DioboxEvent>) => void
  onResetEventWorkingCopy: () => void
}

const StyleAndConfigurationModals = ({
  modalName,
  onHide,
  event,
  updateEvent,
  onChangeEventWorkingCopy,
  onResetEventWorkingCopy,
}: Props) => {
  switch (modalName) {
    case StyleAndConfigurationModalName.PageLogo:
      return (
        <PageLogoModal
          onHide={onHide}
          event={event}
          updateEvent={updateEvent}
          onChangeEventWorkingCopy={onChangeEventWorkingCopy}
          onResetEventWorkingCopy={onResetEventWorkingCopy}
        />
      )
    case StyleAndConfigurationModalName.PageHeader:
      return (
        <PageHeaderModal
          onHide={onHide}
          event={event}
          updateEvent={updateEvent}
          onChangeEventWorkingCopy={onChangeEventWorkingCopy}
          onResetEventWorkingCopy={onResetEventWorkingCopy}
        />
      )
    case StyleAndConfigurationModalName.PublicEventTitle:
      return (
        <EventTitleModal
          onHide={onHide}
          event={event}
          updateEvent={updateEvent}
          onChangeEventWorkingCopy={onChangeEventWorkingCopy}
          onResetEventWorkingCopy={onResetEventWorkingCopy}
        />
      )
    case StyleAndConfigurationModalName.EventDetails:
      return (
        <EventDetailsModal
          onHide={onHide}
          event={event}
          updateEvent={updateEvent}
          onChangeEventWorkingCopy={onChangeEventWorkingCopy}
          onResetEventWorkingCopy={onResetEventWorkingCopy}
        />
      )
    case StyleAndConfigurationModalName.MapLink:
      return (
        <MapLinkModal
          onHide={onHide}
          event={event}
          updateEvent={updateEvent}
          onChangeEventWorkingCopy={onChangeEventWorkingCopy}
          onResetEventWorkingCopy={onResetEventWorkingCopy}
        />
      )
    case StyleAndConfigurationModalName.EventImageAndVideo:
      return (
        <EventImageAndVideoModal
          onHide={onHide}
          event={event}
          updateEvent={updateEvent}
          onChangeEventWorkingCopy={onChangeEventWorkingCopy}
          onResetEventWorkingCopy={onResetEventWorkingCopy}
        />
      )
    case StyleAndConfigurationModalName.DioboxBranding:
      return (
        <DioboxBrandingModal
          onHide={onHide}
          event={event}
          updateEvent={updateEvent}
          onChangeEventWorkingCopy={onChangeEventWorkingCopy}
          onResetEventWorkingCopy={onResetEventWorkingCopy}
        />
      )
    default:
      return null
  }
}

export default StyleAndConfigurationModals
